<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn color="info" small dark class="mt-1" v-on="on">Mail</v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-container>

          <v-text-field
            label="Login"
            :value="active.account.login"
            hide-details
            readonly
          ></v-text-field>
          <v-text-field
            label="Name"
            :value="fullName"
            hide-details
            readonly
          ></v-text-field>

          <v-select
            v-model="from"
            :items="fromList"
            label="From"
            item-text="from"
            return-object
            hide-details
          ></v-select>

          <v-select
            v-model="language"
            :items="newLanguageList"
            label="Language"
            style="z-index: 800"
            hide-details
          ></v-select>

          <v-select
            v-model="tag"
            :items="tags"
            label="Department tag"
            multiple
            style="z-index: 800"
            hide-details
          ></v-select>

          <v-select
            v-model="template"
            :items="filteredTemplates"
            :loading="loading"
            label="Template"
            style="z-index: 800"
            item-text="name"
            return-object
            hide-details
          ></v-select>

          <v-divider v-if="template.variables && template.variables.length > 0" class="mt-5 mb-4" />
          <v-label v-if="template.variables && template.variables.length > 0">Variables:</v-label>
          <v-text-field
            v-for="item in (template.variables || [])"
            :key="item"
            :label="capitalize(item.replace('_', ' '))"
            v-model="variables[item]"
            hide-details
          ></v-text-field>
          <v-divider v-if="template.variables && template.variables.length > 0" class="mt-5 mb-4" />

        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
        <preview :language="language" :template_id="template.template_id" :from="from" :variables="extendedVariables" :closeParent="close" :fromList="fromList" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import jQuery from 'jquery'
  import { mapGetters } from 'vuex'
  import { capitalize, first } from 'lodash'
  import { API } from '@/utils/api'

  global.jQuery = jQuery

  export default {

    components: {
      Preview: () => import('@/components/user/mail/Preview'),
    },

    data: () => ({
      from: {},
      template: {},
      templates: [],
      fromList: [],
      variables: [],
      tag: [],
      loading: false,
      language: false,
      dialog: false,
    }),

    watch: {
      language (val) {
        this.template = {}
        this.loadMailTemplates()
      },
      dialog (val) {
        if (val) {
          this.language = this.active.account.language
          this.variables = []
          this.loadMailTemplates()
          this.loadFromList()
        } else {
          this.template = {}
        }
      }
    },

    computed: {
      ...mapGetters({ active: 'account/active' }),
      newLanguageList () {
        return this.$store.state.auth.languages
      },
      filteredTemplates () {
        if (!Array.isArray(this.tag) || this.tag.length === 0) {
          return this.templates
        }

        return this.templates.filter(t => {
          const tags = t.settings?.tag
          return Array.isArray(tags) && tags.some(tag => this.tag.includes(tag))
        })
      },

      templateList () {
        return this.templates.filter(d => {
          return this.language === 'All' || d.translation.find(({ language }) => this.language === language)
        })
      },
      fullName () {
        return (this.active.account.profile.name || '') + ' ' + (this.active.account.profile.surname || '')
      },
      tags: function () {
        return this.columnValueList('settings.tag')
      },
      extendedVariables () {
        if ((this.variables['username'] || '').length == 0) this.variables['username'] = this.active.account.login
        return {
          name: this.fullName,
          first_name: (this.active.account.profile.name || ''),
          last_name: (this.active.account.profile.surname || ''),
          login: this.active.account.login,
          ...this.variables
        }
      }
    },

    methods: {
      capitalize: (str) => capitalize(str),
      close () {
        this.dialog = false
      },
      columnValueList (val) {

        return _.chain(this.templates)
          .map(d => _.get(d, val))
          .flatten()
          .filter(Boolean)
          .uniq()
          .value()
      },
      loadMailTemplates () {
        this.templates = []
        this.loading = true
        return API.call('/mail/template/list.json', { with_variable: true, language: this.language }, this.active.account).then(resp => {
          this.templates = resp.data
        }).finally(() => {
          this.loading = false
        })
      },
      loadFromList () {
        return API.call('/mail/from.json', { with_variable: true }, this.active.account).then(resp => {
          this.from = first(resp.data)
          this.fromList = resp.data
        })
      },
    }

  }
</script>
